import { dayKey, fromLocalInputValue } from "../time/index.js";
export const PERIOD_PRESETS = ["this-month", "last-month", "this-quarter", "year"];
export function isPeriodPreset(value) {
    return typeof value === "string" && PERIOD_PRESETS.includes(value);
}
/** منتصفُ ليلِ هذا اليوم بتوقيت النظام، كلحظةٍ حقيقية */
function midnight(day, timeZone) {
    const at = fromLocalInputValue(`${day}T00:00`, timeZone);
    if (!at)
        throw new Error(`يومٌ غيرُ مقروء: ${day}`);
    return at;
}
function addDays(day, days) {
    const [y, m, d] = day.split("-").map(Number);
    const at = new Date(Date.UTC(y ?? 1970, (m ?? 1) - 1, (d ?? 1) + days));
    return at.toISOString().slice(0, 10);
}
function firstOfMonth(day, monthsBack) {
    const [y, m] = day.split("-").map(Number);
    const at = new Date(Date.UTC(y ?? 1970, (m ?? 1) - 1 - monthsBack, 1));
    return at.toISOString().slice(0, 10);
}
/**
 * **من يومين إلى فترةٍ محسوبة** — والنهايةُ مفتوحةٌ على منتصف ليل اليوم التالي.
 *
 * فمن طلب «من الأول إلى الحادي والثلاثين» يريد الحادي والثلاثين **داخلاً**:
 * وحدٌّ مغلقٌ على منتصف ليله كان سيُسقط شغلَ يومٍ كامل، **وهو الخطأ الذي يُكتشَف
 * بعد ثلاثة شهورٍ من تصديرٍ ناقص**.
 */
export function periodOf(input, now, timeZone) {
    const today = dayKey(now, timeZone);
    const [fromDay, toDay] = (() => {
        if (input.from && input.to) {
            /** **ومقلوبٌ يُقوَّم لا يُرفَض** — فمن قلب التاريخين يريد المدى بينهما */
            return input.from <= input.to ? [input.from, input.to] : [input.to, input.from];
        }
        switch (input.preset ?? "this-month") {
            case "last-month": {
                const first = firstOfMonth(today, 1);
                return [first, addDays(firstOfMonth(today, 0), -1)];
            }
            case "this-quarter": {
                const month = Number(today.slice(5, 7));
                const back = (month - 1) % 3;
                return [firstOfMonth(today, back), today];
            }
            case "year":
                return [`${today.slice(0, 4)}-01-01`, today];
            case "this-month":
            default:
                return [firstOfMonth(today, 0), today];
        }
    })();
    return {
        from: midnight(fromDay, timeZone),
        to: midnight(addDays(toDay, 1), timeZone),
        fromDay,
        toDay,
    };
}
/**
 * **الفترةُ السابقةُ بنفس الطول** — فالمقارنةُ عادلة.
 *
 * وشهرٌ من ٣١ يوماً يُقارَن بـ٣١ يوماً قبله، لا بشهرٍ تقويميٍّ من ٢٨ — **فسقوطُ
 * ثلاثة أيامٍ من المقام يُظهر تحسّناً لم يحدث**.
 */
export function previousPeriodOf(period, timeZone) {
    const span = period.to.getTime() - period.from.getTime();
    const from = new Date(period.from.getTime() - span);
    return {
        from,
        to: period.from,
        fromDay: dayKey(from, timeZone),
        toDay: dayKey(new Date(period.from.getTime() - 1), timeZone),
    };
}
//# sourceMappingURL=period.js.map